import { Box, BoxProps, Button, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup } from '@chakra-ui/react';
import IconArrowDown from 'assets/icons/icon-arrow-simple-down.svg?react';
import { CONTENT_GROUP_TYPE_NAMES } from 'features/content-groups/components/ContentGroupsList';
import { useActiveContentGroups } from 'features/content-groups/hooks/useActiveContentGroups';
import { useNavigate } from 'react-router-dom';

type ButtonNewEmailProps = BoxProps & {
  type?: string
}

export default function ButtonNewEmail({ type, ...props }: ButtonNewEmailProps) {
  const navigate = useNavigate();

  const { data: contentGroups = [] } = useActiveContentGroups();
  
  return (
    <Box {...props}>
      <Menu>
        <MenuButton 
          as={Button}
          variant="primary"
          w="full"
          textAlign="left"
          rightIcon={<IconArrowDown />}
        >
          Novo Disparo
        </MenuButton>
        <MenuList>
        { !type && Object.keys(CONTENT_GROUP_TYPE_NAMES).map((key) => (
          <MenuOptionGroup fontSize="15px" fontWeight={600} key={key} title={CONTENT_GROUP_TYPE_NAMES[key]}>
          { contentGroups.filter(c => c.type === key).map((contentGroup) => (
            <MenuItemOption
              key={`menu-item-${contentGroup.id}`}
              onClick={() => navigate(`/disparos-de-${key?.toLowerCase()}/novo/${contentGroup.id}`)}
            >
              {contentGroup.name}
            </MenuItemOption>
          ))}
            
          </MenuOptionGroup>
        ))}
        { !!type && contentGroups.filter(c => c.type === type).map((contentGroup) => (
            <MenuItemOption
              key={`menu-item-${contentGroup.id}`}
              onClick={() => navigate(`/disparos-de-${type?.toLowerCase()}/novo/${contentGroup.id}`)}
            >
              {contentGroup.name}
            </MenuItemOption>
          ))}
        </MenuList>
      </Menu>
    </Box>
  )
}
